import {
  IKameleoonData,
  KameleoonData,
  VarGroup,
  ScoredVarIds,
  CBSType,
  CBSDataType,
} from './types';
import { TrackingStatus } from 'src/types';

export class CBScores implements IKameleoonData {
  public status: TrackingStatus;
  private readonly values: Map<number, VarGroup[]>;
  private readonly cbs: CBSType;

  constructor(cbsMap: CBSType) {
    this.values = new Map(
      Object.entries(cbsMap).map(([key, value]) => [
        Number(key),
        this.extractVarIds(value),
      ]),
    );
    this.cbs = cbsMap;
    this.status = TrackingStatus.Sent;
  }

  private extractVarIds(scores: ScoredVarIds): VarGroup[] {
    // keys = experiment IDs / values = list of variation IDs ordered descending
    // by score (there may be several variation ids with same score)
    const grouped = new Map<number, number[]>();

    Object.entries(scores).forEach(([variationId, score]) => {
      if (!grouped.has(score)) {
        grouped.set(score, []);
      }
      grouped.get(score)!.push(Number(variationId));
    });

    return Array.from(grouped.entries())
      .sort(([scoreA], [scoreB]) => scoreB - scoreA)
      .map(([, ids]) => ({ ids: ids.sort((a, b) => a - b) }));
  }

  getValues(): Map<number, VarGroup[]> {
    return this.values;
  }

  get url(): string {
    return '';
  }

  get data(): CBSDataType {
    return {
      cbs: this.cbs,
      type: KameleoonData.CBScores,
      status: this.status,
    };
  }

  public static _fromRaw(data: CBSDataType): CBScores {
    const cbScores = new CBScores(data.cbs);
    cbScores.status = data.status;
    return cbScores;
  }
}
